import type { Hero } from 'types/hero';
import React from 'react';
import { Wrap, RichText } from '@leafwell/components';
import HeadingBody from './heading-body';
import Figure from './figure';

const HeroCareers: React.FC<{ hero: Hero }> = ({
  hero: { subTitle, title, description, image },
}) => (
  <Wrap tagName="header" className="lg:grid-cols-2 lg:gap-x-12">
    <div className="grid gap-y-3 lg:gap-y-0 self-start">
      <HeadingBody title={subTitle} level="4" tagName="h2" />
      <HeadingBody
        title={title}
        level="2"
        tagName="h1"
        className="lg:pt-6 lg:pb-10 leading-snug font-semibold"
      />
      <RichText
        content={description}
        className="leading-7 !text-lg xl:!text-xl"
      />
    </div>
    <div className="justify-self-center relative max-w-md lg:max-w-full overflow-visible">
      <Figure {...image} priority={true} />
      <div className="absolute -z-1 w-full h-full lg:h-3/2 lg:w-3/2 top-0 left-0 lg:left-1/2 lg:-translate-x-2/4 bg-gradient-radial from-green-300/50 to-white"></div>
      <div className="absolute -z-1 w-full h-full lg:h-3/2 lg:w-3/2 bottom-0 left-0 lg:left-1/2 lg:-translate-x-2/4 bg-gradient-radial from-lilac-100 to-transparent"></div>
    </div>
  </Wrap>
);

export default HeroCareers;
